var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 7.625L11.9688 8L12.3438 7.65625C13.375 6.625 14.8438 6.15625 16.25 6.40625C18.4062 6.75 20 8.625 20 10.8125V10.9688C20 12.2812 19.4375 13.5312 18.5 14.4062L12.8438 19.6875C12.625 19.9062 12.3125 20 12 20C11.6562 20 11.3438 19.9062 11.125 19.6875L5.46875 14.4062C4.53125 13.5312 4 12.2812 4 10.9688V10.8125C4 8.625 5.5625 6.75 7.71875 6.40625C9.125 6.15625 10.5938 6.625 11.625 7.625C11.625 7.65625 11.5938 7.625 11.625 7.625ZM11.9688 10.125L10.5625 8.6875C9.875 8.03125 8.90625 7.71875 7.96875 7.875C6.53125 8.125 5.5 9.34375 5.5 10.8125V10.9688C5.5 11.875 5.84375 12.7188 6.5 13.3125L12 18.4375L17.4688 13.3125C18.125 12.7188 18.5 11.875 18.5 10.9688V10.8125C18.5 9.34375 17.4375 8.125 16 7.875C15.0625 7.71875 14.0938 8.03125 13.4062 8.6875L11.9688 10.125Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.9d8ad302d4c363e275e43aa53c9580f4.svg";
export { ForwardRef as ReactComponent };